import axios from 'axios';

import { PlutoClientException } from '@/PlutoClientException';

export type ApiErrorMessageKey = 'error.api.err_unauthorized' | 'error.api.err_forbidden';

export function getApiErrorStatus(error: unknown) {
  if (error instanceof PlutoClientException) {
    return error.statusCode;
  }

  return axios.isAxiosError(error) ? error.response?.status : undefined;
}

export function getApiErrorMessageKey(error: unknown): ApiErrorMessageKey | undefined {
  return getApiErrorMessageKeyForStatus(getApiErrorStatus(error));
}

export function getApiErrorMessageKeyForStatus(status: number | undefined): ApiErrorMessageKey | undefined {
  if (status === 401) {
    return 'error.api.err_unauthorized';
  }

  if (status === 403) {
    return 'error.api.err_forbidden';
  }

  return undefined;
}
